var n = function (l) {
  return l.all = "all", l.row = "row", l.column = "column", l.none = "none", l;
}(n || {});
export { n as ResizeDirection };